<template>
  <div class="order-detail">
    <div class="receive-res text-center" v-show="receiveInit">
      <div class=" fx fx-center fx-items-center" v-if="getOrderParams.originalMemberId">
        <van-icon name="checked" size="20" color="#388BFF" />
        <p class="bold">{{friendName ? 'The gift from ' + friendName + ' has been claimed' : 'The gift has been claimed'}}</p>
      </div>
      <div class="fx fx-center fx-items-center" v-else>
        <van-icon name="checked" size="20" color="#388BFF" />
        <p class="bold">The gift has been sent</p>
      </div>
    </div>
    <div class="cnt">
      <div class="goods" v-if="loading">
        <van-image class="card-img" />
      </div>
      <div class="goods" v-else>
        <div class="card-goods" v-if="pageData.orderUrlImage">
          <van-image class="card-img"
            v-if="!loading && pageData.orderUrlImage"
            :src="pageData.orderUrlImage"/>
          <div class="group fx fx-between" v-for="item in pageData.goodsList" :key="item.goodsId">
            <p>{{item.goodsName}}</p>
            <p>x{{item.goodsNum}}</p>
          </div>
        </div>
        <div class="fx" v-else style="padding-bottom: 20px">
          <van-image class="mr" :width="85" :height="85" :src="goodsData.goodsUrlIco" />
          <div v-if="goodsData.goodsName">
            <p class="name" style="word-wrap: break-word;">{{goodsData.goodsName}}</p>
            <p class="price-box">
              <span>{{pageData.currency | unitFormat}}{{goodsData.priceReal | numFormat(2)}}</span>
              <span class="line-through gray" v-if="pageData.priceReal != pageData.priceSale">{{pageData.currency | unitFormat}}{{goodsData.priceSale | numFormat(2)}}</span>
            </p>
          </div>
        </div>
      </div>
      <div class="details">
        <p class="title">Details</p>
        <div class="group fx fx-between">
          <p class="gray">Order ID</p>
          <p>{{pageData.orderSn}}</p>
        </div>
        <div class="group fx fx-between" v-if="type != 'pay' && pageData.paymentName != 'Transferred' && pageData.orderStatus !== 'Init'">
          <p class="gray">Payment method</p>
          <p>{{pageData.paymentName}}</p>
        </div>
        <div class="group fx fx-between" v-if="pageData.paymentTime">
          <p class="gray">Create Time</p>
          <p>{{Number(pageData.createDate) | dateFormat('minute', '/')}}</p>
        </div>
        <div class="group fx fx-between" v-if="pageData.paymentTime">
          <p class="gray">Purchase Time</p>
          <p>{{Number(pageData.paymentTime) | dateFormat('minute', '/')}}</p>
        </div>
        <div class="group fx fx-between">
          <p class="gray">Quantity</p>
          <p>{{goodsNum}}</p>
        </div>
        <div class="group fx fx-between">
          <p class="gray">Subtotal</p>
          <p>{{pageData.currency | unitFormat}}{{pageData.totalAmount | numFormat(2)}}</p>
        </div>
        <div class="group fx fx-between">
          <p class="gray">Actual payment</p>
          <p>{{pageData.currency | unitFormat}}{{pageData.realAmount | numFormat(2)}}</p>
        </div>
      </div>
      <div class="payment" v-if="(type === 'pay' && pageData.orderStatus != 'Invalid') || pageData.orderStatus === 'Init'">
        <p class="title">Payment</p>
        <van-radio-group v-model="radio" @change="onChangeTap">
          <div class="group fx fx-between fx-items-center" v-for="(item, index) in paymentChannel" :key="item.paymentChannelId">
            <img class="pay-img" :src="item.paymentChannelPic" alt="">
            <van-radio :name="index"></van-radio>
          </div>
        </van-radio-group>
      </div>

      <van-button :disabled="disabled" v-if="type === 'pay' || pageData.orderStatus === 'Init'" type="info" size="large" round @click="onPayTap">
        Pay Now <span v-show="waitingTime">( {{waitingTime}} )</span>
      </van-button>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: true,
      cardHeight: '',
      receiveInit: false,
      type: '',
      paypalParams: {
        token: '',
        totalAmount: '',
        currency: '',
        paymentChannelId: '',
        spbillCreateIp: '127.127.0.1',
        orderId: ''
      },
      getOrderParams: {
        orderId: '',
        token: '',
        originalMemberId: ''
      },
      paymentChannelParams: {
        marketId: '',
        token: ''
      },
      pageData: {},
      goodsData: [],
      disabled: true,
      paymentChannel: [],
      radio: 0,
      goodsNum: 0,
      waitingTime: null,
      friendName: ''
    }
  },
  created () {
    const queryParams = this.$route.query
    this.receiveInit = queryParams.receiveInit ? queryParams.receiveInit : false
    this.type = queryParams.type
    this.friendName = queryParams.name || ''

    let token = this.$util.storageGet('local', 'token') || ''
    this.getOrderParams.token = token
    this.getOrderParams.orderId = queryParams.orderId
    this.getOrderParams.originalMemberId = queryParams.originalMemberId

    this.paypalParams.token = token
    this.paypalParams.orderId = queryParams.orderId

    this.paymentChannelParams.token = token
    this.paymentChannelParams.marketId = this.$util.storageGet('local', 'marketId') // 默认马来西亚 3
    this.loadData()
    /**
       * type === pay 商品详情下单
       * type === check 支付成功查看订单
       */
  },
  methods: {
    // 获取订单详情
    getOrderInfoById (params) {
      return this.$http.post('/olvp/getOrderInfoById', 'getOrderInfoById', params, false, false)
    },
    // 创建paypal支付
    createPaypalOrder (params) {
      return this.$http.post('/olvp/createPaypalOrder', 'createPaypalOrder', params, true, false)
    },
    // 获取支付渠道
    getPaymentChannel (params) {
      return this.$http.post('/olvp/getPaymentChannel', 'getPaymentChannel', params, false, false, false)
    },
    loadData () {
      this.$cux.loading()
      this.getOrderInfoById(this.getOrderParams).then((d) => {
        this.$cux.loadend().then(() => {
          if (d.success) {
            this.pageData = d.content
            this.goodsData = d.content.goodsList[0]
            this.paypalParams.totalAmount = this.pageData.totalAmount
            this.paypalParams.currency = this.pageData.currency
            this.pageData.goodsList.map((v) => {
              this.goodsNum += Number(v.goodsNum)
            })
            this.loading = false
            if (this.goodsNum === 0) {
              this.goodsNum = this.pageData.voucherNumber
            }
            const dateNow = new Date().getTime()
            // 获取支付时间与当前时间的间隔 <约定时间（分钟） 显示倒计时
            let overtime = 15 // 超时时间 后端接口统一
            let paymentTime = this.$util.timeMinus(this.pageData.createDate, dateNow).minute * 60 + this.$util.timeMinus(this.pageData.createDate, dateNow).second
            // 获取支付渠道
            if (this.type === 'pay' || this.pageData.orderStatus === 'Init') {
              this.getPaymentChannel(this.paymentChannelParams).then((d) => {
                if (d.success && d.content.dataList.length > 0) {
                  if (paymentTime <= overtime * 60) {
                    this.countDown(overtime * 60 - paymentTime)
                  }
                  this.paymentChannel = d.content.dataList
                  this.paypalParams.paymentChannelId = this.paymentChannel[0].paymentChannelId
                  this.disabled = false
                }
              })
            }
          } else if (d.errorCode === 'MICRO_ORDER_ORDER_TIME_OUT') {
            setTimeout(() => {
              this.$router.replace(`/myGiftCard`)
            }, 2000)
          }
        })
      })
    },
    // 选择支付渠道
    onChangeTap (e) {
      this.paypalParams.paymentChannelId = this.paymentChannel[e].paymentChannelId
    },
    // 支付
    onPayTap () {
      // if (this.paymentChannel[this.radio].paymentChannelCode === 'paypal') {
      this.disabled = true
      this.createPaypalOrder(this.paypalParams).then((d) => {
        this.disabled = false
        if (d.success) {
          if (d.content.webUrl) {
            this.$util.storageSet('session', 'hideToast', false)
            window.location.href = d.content.webUrl
            // window.open(d.content.webUrl)
          } else {
            if (d.content.orderComplete) {
              this.$router.push(`/giveFriends?orderId=${this.getOrderParams.orderId}&status=success&from=pay`)
            } else {
              this.$cux.toast('Can not connect to payment gateway. Please try again later.')
            }
          }
        } else if (d.errorCode === 'MICRO_ORDER_ORDER_TIME_OUT') {
          this.disabled = true
          setTimeout(() => {
            this.$router.replace(`/myGiftCard`)
          }, 2000)
        }
      })
      // } else {
      //   this.$cux.toast('不支持其他支付渠道')
      // }
    },
    countDown (t) {
      let beforeTime = Date.now()
      const timer = setInterval(() => {
        t = t - (((Date.now() - beforeTime) / 1000).toFixed(0))
        if (t >= 1) {
          beforeTime = Date.now()
          this.waitingTime = this.remainTime(t)
        } else {
          this.disabled = true
          this.waitingTime = null
          clearInterval(timer)
        }
      }, 1000)
    },
    zeroFill (num) {
      num = num.toString()
      return num[1] ? num : '0' + num
    },
    /**
     * 剩余时间 分、秒
     * @param sec 秒数
     */
    remainTime (sec) {
      const remainMinute = Math.floor(sec / 60)
      const remainSecond = sec - remainMinute * 60
      return (
        this.zeroFill(remainMinute) + ':' + this.zeroFill(remainSecond)
      )
    }
  }
}
</script>

<style lang="scss">
  .order-detail {
    width: 100%;
    height: 100%;
    background: #fff;
    .preload-img {
      border-radius: 8px;
      overflow: hidden;
      display: block;
      margin: 0 auto;
      border-radius: 8px;
    }
    .receive-res {
      padding: 15px 15px 0 15px;
      p {
        margin-left: 8px;
        font-size: 16px;
      }
    }
    .cnt {
      padding: 15px;
    }
    .btns {
      width: 100%;
      position: absolute;
      bottom: 40px;
      .back {
        font-size: 15px;
      }
    }
    .card-img {
      display: block;
      width: 70%;
      margin: 0 auto;
      box-shadow: 5px 5px 10px #dbdbdb;
      border-radius: 8px;
      overflow: hidden;
      margin-bottom: 15px;
    }
    .card-goods {
      margin-top: 20px;
      padding-bottom: 10px;
    }
    .btn {
      width: 100%;
      padding: 0 20px;
      margin-top: 20px;
    }
    .btn.padding {
      padding-top: 60px;
    }
    .goods {
      border-bottom: 1px solid #eee;
      .name {
        font-size: 17px;
        margin-bottom: 3px;
      }
      .mr {
        margin-right: 12px;
        flex: none;
      }
    }
    .title {
        font-size: 17px;
      }
      .group {
        padding: 10px 0;
        font-size: 15px;
      }
    .details {
      padding: 15px 0;
      padding-bottom: 5px;
      border-bottom: 1px solid #eee;
      .title {
        margin-bottom: 10px;
      }
    }
    .payment {
      .title {
        margin-bottom: 10px;
      }
      padding: 15px 0 30px 0;
      .pay-img {
        width: 80px;
      }
      .checkbox {
        width: 22px;
        height: 23px;
      }
    }
  }
</style>
